import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Gaan alcohol en afvallen samen?</title>
                <link rel="canonical" href={route("blogs.nineteenth")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Ons darmkanaal regelt onze ‘binnenwereld’. De perfect uitgevoerde werkzaamheden starten bij de mond, het portaal naar de wereld van onze darmen. Ons darmkanaal is daarom een onderschatte factor als het gaat om een snelle transformatie. In deze nieuwe blog van WE ARE – personal training Uden en Schijndel duiken we dieper in op ons spijsvertering systeem!"
                />
                <meta
                    property="og:description"
                    content="Ons darmkanaal regelt onze ‘binnenwereld’. De perfect uitgevoerde werkzaamheden starten bij de mond, het portaal naar de wereld van onze darmen. Ons darmkanaal is daarom een onderschatte factor als het gaat om een snelle transformatie. In deze nieuwe blog van WE ARE – personal training Uden en Schijndel duiken we dieper in op ons spijsvertering systeem!"
                />
                <meta property="og:url" content={route("blogs.nineteenth")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Gaan alcohol en afvallen samen? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/alcohol-en-afvallen.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh]  pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/alcohol-en-afvallen.webp"
                                    type="image/webp"
                                    alt="Alchohol en afvallen"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/alcohol-en-afvallen.jpg"
                                    type="image/jpeg"
                                    alt="Alchohol en afvallen"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/alcohol-en-afvallen.jpg"
                                    alt="Alchohol en afvallen"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Gaan alcohol en afvallen samen?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Een veel besproken onderwerp tijdens een dieet is
                        natuurlijk het gebruik van alcohol. In het ene dieet
                        wordt het toegelaten waarbij het in het andere dieet
                        wordt verboden. Om te kunnen bepalen of een verstandige
                        keuze is, is het belangrijk dat je de voor,- en nadelen
                        kent en weet hoe je hiermee moet omgaan. WE ARE –
                        personal training Uden en Schijndel gaat je hierbij
                        helpen in deze gloednieuwe blog!
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat is alcohol?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Alcohol is een stof die zowel in drinken als eten zit.
                        Het is een chemische verbinding met als meest bekende
                        vorm: ethanol. Alcohol ontstaat als fruit of graan gaan
                        gisten. Gist zet de suiker om in alcohol. De combinatie
                        van temperatuur en hoeveelheid suiker bepaald
                        uiteindelijk de snelheid en hoeveelheid waarmee alcohol
                        ontstaat. Door het te verhitten en weer af te koelen kan
                        het percentage worden verhoogd.
                    </p>
                    <ul className="mt-4 text-gray-100 list-disc">
                        <li>Per gram ongeveer 7 calorieën bevat.</li>
                        <li>
                            Remt en beperkt de anabole processen die leiden tot
                            spiergroei{" "}
                        </li>
                        <li>
                            Verlaagt je testosteronwaarde en hierdoor kan je
                            minder snel spiermassa ontwikkelen{" "}
                        </li>
                        <li>
                            Verhoogt de cortisolwaarden in ons lichaam en
                            bevordert hierdoor buikvet{" "}
                        </li>
                        <li>Remt het herstellend vermogen van onze spieren </li>
                        <li>Versterkt de drang naar vette trek </li>
                        <li>
                            Lege calorieën bevat en dus geen enkele
                            voedingswaardes heeft
                        </li>
                    </ul>
                    <p className="mt-4 text-gray-100 break-words">
                        Je ziet dat alcohol veel negatieve effecten veroorzaakt.
                        De juiste balans tussen het gebruik van alcohol en het
                        doel is dus van uiterst belang!
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Gaat alcohol en afvallen samen?{" "}
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Alcoholhoudende dranken bestaat al meer dan 5000 jaar.
                        Het is een onderdeel van ons leven geworden en als WE
                        ARE begrijpen we dat een glaasje op zijn tijd erbij
                        hoort. Zelfs wanneer je alcohol drinkt kan je resultaten
                        boeken. Je dient alleen te begrijpen dat elke vorm van
                        alcohol bovenstaande negatieve effecten veroorzaakt.
                        Hierdoor dien je te allen tijde af te vragen of het
                        verstandig is om alcohol te drinken wanneer je bezig
                        bent met afvallen.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat als je toch graag een glaasje drinkt?{" "}
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Wanneer je toch graag een glaasje drinkt en bezig bent
                        met afvallen dan raden wij aan om dit te beperken tot
                        maximaal 1 keer per week. Wanneer je drinkt adviseren
                        wij pure wodka gemixt met zero frisdrank. Dit bevat
                        namelijk 50 tot 60 calorieën in tegenstelling tot
                        bijvoorbeeld een biertje waarbij je al gauw 120
                        calorieën drinkt. Ga ook niet voor kant en klare
                        mixdrankjes, deze bevatten vaak frisdrank met veel
                        suiker en bevatten zelfs een hoger aantal calorieën dan
                        bier.
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl">
                        In welke alcoholhoudende dranken zitten de minste
                        calorieën?
                    </h3>
                    <div className="space-y-12 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:grid-cols-3 lg:gap-x-8">
                        <div className="space-y-4">
                            <h4 className="text-we-are-yellow mt-8 font-bold uppercase xs:text-xl sm:text-xl">
                                Wijn
                            </h4>
                            <p className="mt-4 text-gray-100 italic">
                                Per glas (150ml)
                            </p>
                            <ul className="mt-4 text-gray-100">
                                <li className="pl-0 ml-0">
                                    Droge witte wijn: 101 kcal
                                </li>
                                <li className="pl-0 ml-0">
                                    Zoete witte wijn: 144 kcal
                                </li>
                                <li className="pl-0 ml-0">
                                    Rode wijn: 123 kcal
                                </li>
                                <li className="pl-0 ml-0">
                                    Rose wijn: 107 kcal
                                </li>
                            </ul>
                        </div>

                        <div className="space-y-4">
                            <h4 className="text-we-are-yellow mt-8 font-bold uppercase xs:text-xl sm:text-xl">
                                Champagne of mousserend
                            </h4>
                            <p className="mt-4 text-gray-100 italic">
                                Per glas (85ml)
                            </p>
                            <ul className="mt-4 text-gray-100">
                                <li className="pl-0 ml-0">
                                    Champagne: 57 kcal
                                </li>
                                <li className="pl-0 ml-0">Prosecco: 50 kcal</li>
                                <li className="pl-0 ml-0">
                                    Rode wijn: 123 kcal
                                </li>
                                <li className="pl-0 ml-0">
                                    Rose wijn: 107 kcal
                                </li>
                            </ul>
                        </div>

                        <div className="space-y-4">
                            <h4 className="text-we-are-yellow mt-8 font-bold uppercase xs:text-xl sm:text-xl">
                                Whisky
                            </h4>
                            <p className="mt-4 text-gray-100 italic">
                                Per glas (35ml)
                            </p>
                            <ul className="mt-4 text-gray-100">
                                <li className="pl-0 ml-0">Whisky: 85 kcal</li>
                            </ul>
                        </div>

                        <div className="space-y-4">
                            <h4 className="text-we-are-yellow mt-8 font-bold uppercase xs:text-xl sm:text-xl">
                                Bier
                            </h4>
                            <p className="mt-4 text-gray-100 italic">
                                Per glas (250ml)
                            </p>
                            <ul className="mt-4 text-gray-100">
                                <li className="pl-0 ml-0">
                                    Gewoon bier, pils: 110 kcal
                                </li>
                                <li className="pl-0 ml-0">
                                    Bier, oud bruin: 90 kcal
                                </li>
                                <li className="pl-0 ml-0">
                                    Speciaalbiertje, zoals een La Chouffe: 241
                                    kcal
                                </li>
                            </ul>
                        </div>

                        <div className="space-y-4">
                            <h4 className="text-we-are-yellow mt-8 font-bold uppercase xs:text-xl sm:text-xl">
                                Sterke drank
                            </h4>
                            <p className="mt-4 text-gray-100 italic">
                                Per glas (35ml)
                            </p>
                            <ul className="mt-4 text-gray-100">
                                <li className="pl-0 ml-0">Rum: 80 kcal</li>
                                <li className="pl-0 ml-0">Gin: 70 kcal</li>
                                <li className="pl-0 ml-0">
                                    Likeur, zoals Contreau: 188 kcal
                                </li>
                                <li className="pl-0 ml-0">Wodka: 86 kcal</li>
                            </ul>
                        </div>

                        <div className="space-y-4">
                            <h4 className="text-we-are-yellow mt-8 font-bold uppercase xs:text-xl sm:text-xl">
                                Cocktails
                            </h4>
                            <ul className="mt-4 text-gray-100">
                                <li className="pl-0 ml-0">
                                    Manhattan: 164 kcal
                                </li>
                                <li className="pl-0 ml-0">
                                    Whiskey sour: 122 kcal
                                </li>
                                <li className="pl-0 ml-0">
                                    Margarita: 280 kcal
                                </li>
                                <li className="pl-0 ml-0">
                                    Gin-Tonic: 168 kcal
                                </li>
                                <li className="pl-0 ml-0">
                                    Caipirinha: 236 kcal
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
